import React, {useState, useMemo, useRef} from 'react';
import { withStyles, Typography, Tooltip, IconButton } from '@material-ui/core';
import { connect } from 'react-redux';
import NicsList from './NICList';
import { hasPermission, hasAtLeastOnePermission, parseURL, createHistory } from '../../sc-utilities';
import { Edit } from '@material-ui/icons';
import * as actions from './store/nicActions';
import { Redirect } from 'react-router-dom';

const styles = theme => ({
    root: {
        width: `100%`,
        height: 'auto',
        marginTop: '-1%',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            width: '100%'
        }
    },
    "@global": {
        "[class*='statusActive']": {
            color: theme.palette.success.dark
        },
        "[class*='statusInactive']": {
            color: theme.palette.error.dark
        },
        "[class*='button']": {
            textTransform: 'none',
            textDecoration: 'none'
        }
    },
    button: {
        textTransform: 'none',
        textDecoration: 'none'
    },
    statusActive: {
        color: theme.palette.success.dark
    },
    statusInactive: {
        color: theme.palette.error.dark
    }
});

const NIC = props => {
    const tableRef = useRef();
    const { classes, translations, permissions, editable, columns } = props;
    let visible = columns && columns['NIC'];
    let searchParams = parseURL(window.location.search);

    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, storageComponentID: null, redirectPath: "" });

    const tableColumns = useMemo(() => {
        return [{
            title: translations["action"] || "Action", field: 'Action',
            hidden: visible ? visible['Action'] : false,
            cellStyle: { minWidth: 200, maxWidth: 200 },
            filtering: false,
            render: rowData => {
                return (<>
                    <Tooltip title={translations["edit_nic"] || "Edit nic"}>
                        <IconButton value={rowData.ComponentID} aria-label={translations["edit_nic"] || "Edit nic"} onClick={(event) => goToEditNICComponent(event, rowData)}>
                            <Edit />
                        </IconButton>
                    </Tooltip>
                </>
                )
            }
        },
        {
            title: translations["type"] || 'Type', field: 'Type',
            hidden: visible ? visible['Type'] : false,
            filtering: false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ComponentType ? translations[rowData.ComponentType] || "NIC" : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["vendor"] || 'Vendor', field: 'Vendor',
            hidden: visible ? visible['Vendor'] : false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Vendor ? rowData.Vendor : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["model"] || 'Model', field: 'ComponentModel',
            hidden: visible ? visible['ComponentModel'] : false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.ComponentModel ? rowData.ComponentModel : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["serial_number"] || 'Serial Number', field: 'SerialNumber',
            hidden: visible ? visible['SerialNumber'] : false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.SerialNumber ? rowData.SerialNumber : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["description"] || 'Description', field: 'Description',
            hidden: visible ? visible['Description'] : false,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Description ? rowData.Description : translations['short_not_assigned'] || 'n/a'}</Typography>;
            }
        },
        {
            title: translations["deleted"] || 'Deleted', field: 'Deleted',
            hidden: visible ? visible['Deleted'] : false,
            lookup: { '1': translations['yes'] || 'Yes', '0': translations['no'] || 'No' },
            defaultFilter: ['0'],
            width: 100,
            render: rowData => {
                return <Typography variant={'caption'}>{rowData.Deleted ? translations['yes'] || 'Yes' : translations['no'] || 'No'}</Typography>;
            }
        }
        ];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes, translations, visible])
    const goToEditNICComponent = (event, rowData) => {
        createHistory();
        setRedirectOptions({ redirect: true, ComponentID: rowData.ComponentID, redirectPath: `/nicDetails/edit?ComponentID=${rowData.ComponentID}&&productID=${searchParams.productID}&&editable=${editable ? '1' : '0'}` });
    };
    const handleOpen = () => {
        createHistory();
        setRedirectOptions({ redirect: true, ComponentID: null, redirectPath: `/nicDetails/create?productID=${searchParams.productID}` });
    };

    if (!hasAtLeastOnePermission(permissions, [
        "component_create",
        "component_load",
        "component_delete"
    ])) {
        tableColumns.shift();
    }
    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    return (
        <div className={classes.root}>
            {hasPermission(permissions, 'component_list') ?
                <NicsList editable={editable} productID={props.productID} handleOpen={handleOpen} tableColumns={tableColumns} tableRef={tableRef} />
                : null}

        </div >
    );

}
const mapStateToProps = state => {
    return {
        permissions: state?.core?.login?.permissions || [],
        nics: state.product.nics,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onFetchNICs: filter => dispatch(actions.fetchNIC(filter))
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(NIC))
